<script setup lang="ts">
    const { locale, language } = useLocales();
</script>
<template>
    <button
        :aria-label="$t('cta.helpscout')"
        :class="['flex h-12 w-12 transition-colors lg:h-10 lg:w-10', $helpScout?.loading ? 'opacity-60' : 'hover:text-woom-red focus:text-woom-red']"
        :disabled="$helpScout?.loading"
        @click="$helpScout.open(locale, language)">
        <woom-icon-help-bubble class="m-auto h-6 w-6 fill-current" />
    </button>
</template>
